"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActivePaymentProcessorAccountByProcessor = exports.getPrimaryPaymentProcessorAccount = exports.getActivePaymentProcessorAccounts = exports.HaulerPaymentProcessorAccountUpsertTransport = exports.HaulerPaymentProcessorAccountTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const invoice_1 = require("../invoice");
const hauler_payment_processing_1 = require("./hauler-payment-processing");
exports.HaulerPaymentProcessorAccountTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    paymentProcessor: invoice_1.SupportedPaymentProcessorTransport,
    merchantID: typebox_1.Type.String(),
    merchantApplicationID: typebox_1.Type.Optional(typebox_1.Type.String()),
    applicationStatus: typebox_1.Type.Optional(typebox_1.Type.Union(Object.values(hauler_payment_processing_1.HaulerPaymentProcessorOnboardingApplicationStatus).map((status) => typebox_1.Type.Literal(status)))),
    active: typebox_1.Type.Boolean(),
    primary: typebox_1.Type.Boolean(),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.HaulerPaymentProcessorAccountUpsertTransport = typebox_1.Type.Omit(exports.HaulerPaymentProcessorAccountTransport, [
    'id',
    'metadata',
]);
const getActivePaymentProcessorAccounts = (accounts) => accounts.filter((account) => account.active);
exports.getActivePaymentProcessorAccounts = getActivePaymentProcessorAccounts;
const getPrimaryPaymentProcessorAccount = (accounts) => accounts.find((account) => account.primary);
exports.getPrimaryPaymentProcessorAccount = getPrimaryPaymentProcessorAccount;
const getActivePaymentProcessorAccountByProcessor = (accounts, paymentProcessor) => accounts.find((account) => account.active && account.paymentProcessor === paymentProcessor);
exports.getActivePaymentProcessorAccountByProcessor = getActivePaymentProcessorAccountByProcessor;
//# sourceMappingURL=hauler-payment-processor-account-transport.js.map